// extracted by mini-css-extract-plugin
export default {"header":"skeleton_header__qGjsx","logo":"skeleton_logo__ecGkQ","content":"skeleton_content__Lvp7v","nav":"skeleton_nav__OFBMT","navBottom":"skeleton_navBottom__pzOhw"};